// extracted by mini-css-extract-plugin
module.exports = {"table":"table--f15ya"};